import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import MyGuestsTable from "./MyGuestsTable";
import MyGuestsCount from "./MyGuestsCount";
import MyGuestsStatistics from "./MyGuestsStatistics";
import MyGuestsButton from "./MyGuestsButton";
import MyGuestsDate from "./MyGuestsDate";
import MyGuestsGratitude from "./MyGuestsGratitude";
import { totalinvitados, estadisticainvitados, botoninvitados, infotabla, fechaInvitacion, putSendInvitationNow } from 'services/rsvp/getRSVP';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import styles from './styles.module.scss';
import { useHistory } from 'react-router-dom'
import { useWindowSize } from 'hooks';
import { Modal } from 'components';
import sobre_ok from 'assets/img/sobre_ok.png';

const MyGuests = ({ typeId }) => {
  console.log('En MyGues con invitados');
  const [, { isMobile }] = useWindowSize();
  const history = useHistory()
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [servicioTotalInvitados, setServicioTotalInvitados] = useState('');
  const [servicioEstadisticainvitados, setServicioEstadisticainvitados] = useState('');
  const [servicioBotonInvitados, setServicioBotonInvitados] = useState('');
  const [servicioInfoTabla, setServicioInfoTabla] = useState('');
  const [cargando, setCargando] = useState(0);
  const [infoTablaCargada, setInfoTablaCargada] = useState(false);
  const [activeItemIds, setActiveItemIds] = useState([]);
  const [botonDesactivado, setBotonDesactivado] = useState(true);
  const [refreshTable, setRefreshTable] = useState(false);
  const [servicioFechaInvitacion, setServicioFechaInvitacion] = useState('');
  const [refreshDate, setRefreshDate] = useState(false);
  const [cantidadRegistros, setCantidadRegistros] = useState(0);
  const [scheduledInvitationDate, setScheduledInvitationDate] = useState(true); // true Fecha programada aun no enviada  false Fecha programada ya enviada
  const [sendInvitation, setSendInvitation] = useState([]);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [sendInvitationNow, setSendInvitationNow] = useState(false);
  const [sendInvitationTotal, setSendInvitationTotal] = useState(0);

  const handleGetRefreshDate = () => {
    setRefreshDate(!refreshDate);
    // console.log('handleGetRefreshDate okis',refreshDate);
  };

  useEffect(() => {
    dispatch(showLoader());
    console.log('Cargando info ');

    totalinvitados(typeId).then((valorDeServicio) => {
      setServicioTotalInvitados(valorDeServicio);
      // console.log('totalinvitados ', valorDeServicio);
    });

    estadisticainvitados(typeId).then((valorDeServicio) => {
      setServicioEstadisticainvitados(valorDeServicio);
      // console.log('estadisticainvitados ', valorDeServicio);
    });

    botoninvitados(typeId).then((valorDeServicio) => {
      setServicioBotonInvitados(valorDeServicio);
      // console.log('botoninvitados ', valorDeServicio);
    });

    fechaInvitacion(typeId).then((valorDeServicio) => {
      setServicioFechaInvitacion(valorDeServicio);
      console.log('serviciofechaInvitacion ', valorDeServicio);
      if(valorDeServicio != undefined){
        const dateStr = valorDeServicio?.data?.items;
        const parts = dateStr.split('/');
        const formattedDateStr = `20${parts[2]}-${parts[1]}-${parts[0]}`;
        const dateUnixTimestamp = Math.floor(new Date(formattedDateStr).getTime() / 1000);
        const currentDate = new Date();
        const unixTimestamp = Math.floor(currentDate.getTime() / 1000);
        console.log('Revisa fecha: dateUnixTimestamp:',dateUnixTimestamp,'< unixTimestamp:',unixTimestamp);
        console.log('Revisa fecha: formattedDateStr', formattedDateStr, '< currentDate: ',currentDate);

        if (dateUnixTimestamp < unixTimestamp) {
          //alert ('La fecha de envio ya paso.');
          setScheduledInvitationDate(false);
        } else {
          //alert ('La fecha de envio aun no pasa');
          setScheduledInvitationDate(true);
        }
      }
    });

    infotabla(typeId).then((valorDeServicio) => {
      setServicioInfoTabla(valorDeServicio?.data?.items);
      console.log('infotabla ', valorDeServicio);
      setCargando(cargando + 1);
      setInfoTablaCargada(true);
    });

  }, [refreshTable, refreshDate]);

  useEffect(() => {
    if (cargando >= 1) {
      dispatch(hideLoader());
    }
  }, [cargando]);

  const handleGetActiveItemIds = (itemIds) => {
    setActiveItemIds(itemIds);
  };

  const handleClickEnvioInvitacion = () => {
    console.log('Invitaciones a enviar total ', activeItemIds.length);
    console.log('Invitaciones a enviar ', activeItemIds);
    let SendInvitationID = activeItemIds;
    const nuevoRegistroEnvio = {
      typeId,
      SendInvitationID
    };
    setSendInvitation(nuevoRegistroEnvio);
  };

  const handleClickEnvioInvitacionAhora = () => {
    setSendInvitationNow(!sendInvitationNow);
    setShow(false);

  };

  const handleGetRefresh = () => {
    setRefreshTable(!refreshTable);
    console.log('cantidad de registrso', servicioInfoTabla.length)
    setCantidadRegistros(servicioInfoTabla.length);
  };

  const handleEditInvitation = () => {
    history.push('/agrega-invitados-excel/'+typeId+'/6/load');
  };

  const sendInvitationMassive = async (SendInvitationID) => {
    dispatch(showLoader());
    for (const value of SendInvitationID) {
      putSendInvitationNow(value).then((valorDeServicio) => {
        console.log('Enviando invitación', value, 'de la mesa', typeId, 'resultado:', valorDeServicio);
      });

      // Agrega una pausa de 1 segundos
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    dispatch(hideLoader());
    setShow2(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleClose2 = () => {
    setShow2(false);
      // ACTUALIZA PAGINA
      setRefreshTable(!refreshTable);
  };

  useEffect(() => {
    if (activeItemIds.length > 0) {
      setBotonDesactivado(false);
    } else {
      setBotonDesactivado(true);
    }
  }, [activeItemIds]);

  useEffect(() => {
    if (cantidadRegistros == 1) {
      console.log('redireccionando a rsvp');
      window.location.reload();
    }
  }, [cantidadRegistros]);

  useEffect(() => {
    console.log('sendInvitation ', sendInvitation);
    console.log('sendInvitation total', sendInvitation?.SendInvitationID?.length);
    console.log('scheduledInvitationDate ', scheduledInvitationDate);

    setSendInvitationTotal(sendInvitation?.SendInvitationID?.length);

    if (sendInvitation?.SendInvitationID?.length) {
      if (scheduledInvitationDate) {
        //    Enviar invitaciones
        sendInvitationMassive(sendInvitation?.SendInvitationID);
        //alert ('Enviando invitaciones masivas ' + sendInvitation?.SendInvitationID?.length);
      } else {
        //alert ('¡La fecha del envió ya paso!, Quieres enviar las invitaciones de todas formas? ' + sendInvitation?.SendInvitationID?.length);
        setShow(true);
      }
    }
  }, [sendInvitation]);

  useEffect(() => {
    console.log('sendInvitation sendInvitationNow', sendInvitation);
    console.log('sendInvitation total sendInvitationNow ', sendInvitation?.SendInvitationID?.length);
    console.log('scheduledInvitationDate sendInvitationNow ', scheduledInvitationDate);

    setSendInvitationTotal(sendInvitation?.SendInvitationID?.length);

    if (sendInvitation?.SendInvitationID?.length) {
      //    Enviar invitaciones
      sendInvitationMassive(sendInvitation?.SendInvitationID);
      //alert ('Enviando invitaciones masivas sendInvitationNow' + sendInvitation?.SendInvitationID?.length);
    }
  }, [sendInvitationNow]);


  const [tabActive, setTabActive] = useState(isMobile)
  return (
    <>
      <div className={`${styles.myguest} container-fluid `}>
        <div className='row'>
          <div className='col-md-3 my-3'>
            {!isMobile && (<h1><b>Mis invitados   {/*typeId*/}</b></h1>)}
          </div>
        </div>
        <div className='row'>
          <div className={`col-md-4 ${!isMobile ? 'border-right border-bottom' : 'border rounded p-4'}`}>
            <MyGuestsCount totalinvitados={servicioTotalInvitados} />
          </div>
          <hr></hr>
          <div className={`col-md-5 ${!isMobile ? 'border-bottom' : 'border rounded p-4'}`}>
            <MyGuestsStatistics estadisticainvitados={servicioEstadisticainvitados} botoninvitados={servicioBotonInvitados} />
          </div>
          {!isMobile && (
            <div className="col-md-3">
              <MyGuestsButton botoninvitados={servicioBotonInvitados} />
            </div>
          )}
        </div>
        <br />
        {infoTablaCargada && <MyGuestsTable data={servicioInfoTabla} onGetActiveItemIds={handleGetActiveItemIds} onGeRefresh={handleGetRefresh} />}
        {console.log('activeItemIds ', activeItemIds)     /*    ELIMINAR    */}
        {/*JSON.stringify(activeItemIds) */                   /*    ELIMINAR    */}
        <br />
        <div className='row'>
          {isMobile && (
            <div className="d-flex justify-content-between">
              <Button
                id={2}
                onClick={() => setTabActive(true)}
                variant={tabActive ? 'primary' : 'secondary'}
                type="button"
                className={'btn-xs m-1'}
                style={{ borderRadius: '13px' }}
              >
                Invitación
              </Button>
              <Button
                id={2}
                onClick={() => setTabActive(false)}
                variant={!tabActive ? 'primary' : 'secondary'}
                type="button"
                className={'btn-xs m-1'}
                style={{ borderRadius: '13px' }}
              >
                Agradecimiento
              </Button>
            </div>
          )}
          <div className='col-md-5 mb-2'>
            {!isMobile ? (
              <div className='border rounded p-4'>
                <MyGuestsDate typeId={typeId} fechainvitacion={servicioFechaInvitacion} onGetRefreshDate={handleGetRefreshDate} />
              </div>
            ) : tabActive && (
              <div className='border rounded p-4'>
                <MyGuestsDate typeId={typeId} fechainvitacion={servicioFechaInvitacion} onGetRefreshDate={handleGetRefreshDate} />
              </div>
            )
            }

          </div>
          <div className='col-md-5 mb-2'>
            {!isMobile ? (
              <div className='border rounded p-4'>
                <MyGuestsGratitude />
              </div>
            ) : !tabActive && (
              <div className='border rounded p-4'>
                <MyGuestsGratitude />
              </div>
            )}
          </div>
          <div className='col-md-2'></div>
        </div>

        <br />
        <div className="col text-center">
          <span>Selecciona invitados y manda tu invitación individualmente</span>
        </div>
        <br />
        <div className="row justify-content-md-center">
  {scheduledInvitationDate ? (
    <>
      <div className='col-md-6 mb-3'>
        <Button
          id={1}
          block
          variant="secondary"
          onClick={handleEditInvitation}
          type="button"
        >
          Editar Invitacion
        </Button>
      </div>
      <div className='col-md-6 mb-3'>
        <Button
          id={2}
          block
          variant="secondary"
          onClick={handleClickEnvioInvitacion}
          type="button"
          className={botonDesactivado ? 'text-white' : 'text-red'}
          disabled={botonDesactivado}
        >
          Enviar invitación ahora
        </Button>
      </div>
    </>
  ) : (
    <div className='col-md-6 mb-3'>
      <Button
        id={2}
        block
        variant="secondary"
        onClick={handleClickEnvioInvitacion}
        type="button"
        className={botonDesactivado ? 'text-white' : 'text-red'}
        disabled={botonDesactivado}
      >
        Enviar invitación ahora
      </Button>
    </div>
  )}
</div>

        <br /><br />
      </div>
      <Modal
        size="md"
        title=""
        show={show}
        onClose={handleClose}
        variant="completed"
        variantOnlyInMobile
        showCancel={false}
        withHeader={false}
        withActionButtons={false}
      >
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h3><b>&nbsp;&nbsp;&nbsp;</b></h3>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h3><b>¡La fecha del envió ya paso!</b></h3>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h2>La fecha del envío<br />programada para las<br />invitaciones ya pasó.</h2>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <Button
              id={21}
              block
              variant="primary"
              onClick={handleClickEnvioInvitacionAhora}
              type="button"
            >
              Enviar invitación
            </Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        size="lg"
        title=""
        show={show2}
        onClose={handleClose2}
        variant="completed"
        variantOnlyInMobile
        icon={sobre_ok}
        showCancel={false}
        withHeader={false}
        withActionButtons={false}
      >
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h3><b>¡Invitación enviada!</b></h3>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h2>Se ha enviado tu invitación digital a <b>{sendInvitationTotal}</b> invitados.</h2>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h2>
              Con el envío de tu invitación, solicitaremos la<br />confirmación de asistencia para asegurarnos de<br />tener una lista precisa de los que estarán presentes.
            </h2>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <Button
              id={21}
              block
              variant="primary"
              onClick={handleClose2}
              type="button"
            >
              Entendido
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default MyGuests;
